import React from 'react';
import { Menu } from 'lucide-react';
import { Logo } from './Logo';

export const Header = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header
      style={{
        background: 'var(--bg-primary)',
        borderBottom: '1px solid var(--border-subtle)',
        padding: '16px 7.6923%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 0,
        width: '100%',
        height: '80px',
        zIndex: 10,
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          cursor: 'pointer',
        }}
        onClick={() => scrollToSection('hero')}
      >
        <Logo size="default" />
      </div>
      <nav
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '32px',
        }}
        className="desktop-nav"
      >
        <button
          onClick={() => scrollToSection('features')}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 400,
            transition: 'color 0.3s ease',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'var(--text-primary)')}
          onMouseLeave={(e) => (e.target.style.color = 'var(--text-muted)')}
        >
          Fitur
        </button>
        <button
          onClick={() => scrollToSection('how-it-works')}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 400,
            transition: 'color 0.3s ease',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'var(--text-primary)')}
          onMouseLeave={(e) => (e.target.style.color = 'var(--text-muted)')}
        >
          Cara Kerja
        </button>
        <button
          onClick={() => scrollToSection('pricing')}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 400,
            transition: 'color 0.3s ease',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'var(--text-primary)')}
          onMouseLeave={(e) => (e.target.style.color = 'var(--text-muted)')}
        >
          Harga
        </button>
        <button
          onClick={() => scrollToSection('faq')}
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            fontSize: '18px',
            fontWeight: 400,
            transition: 'color 0.3s ease',
          }}
          onMouseEnter={(e) => (e.target.style.color = 'var(--text-primary)')}
          onMouseLeave={(e) => (e.target.style.color = 'var(--text-muted)')}
        >
          FAQ
        </button>
      </nav>
      <style>
        {`
          @media (max-width: 767px) {
            .desktop-nav {
              display: none;
            }
          }
        `}
      </style>
    </header>
  );
};